// extracted by mini-css-extract-plugin
var _1 = "xULcca";
var _2 = "Ha83M_";
var _3 = "VwT6Bp";
var _4 = "ceVVvl";
var _5 = "tgGKEn";
var _6 = "asNwmS";
var _7 = "oZ6MqT";
var _8 = "KSA3OB";
var _9 = "CAWOys";
export { _1 as "arrow-16-v", _2 as "ease-transition", _3 as "gradient-titanic-80", _4 as "linear-transition-05", _5 as "rotate-180", _6 as "shadow-medium-titanic", _7 as "shadow-medium-titanic-hover", _8 as "shadow-titanic-1", _9 as "shadow-white" }
